const DojoWebPosTransactionType = Object.freeze({
    SALE: 'Sale',
    REFUND: 'Refund',
});

module.exports = DojoWebPosTransactionType;
